import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CombinedOrderWithOrdersDto, PagedResult } from 'app/models/order';

export type SortBy = 'id' | 'created_at' | 'updated_at' | 'grand_total';
export type SortDir = 'asc' | 'desc';

export interface UpdateOrdersStatus{
orders_ids : number[];
status :string
}
@Injectable({
  providedIn: 'root'
})
export class OrderService {
  private get apiUrl(): string {
    const base = localStorage.getItem('apiURL');
    if (!base) throw new Error('apiURL not ready');
    return base + "/api/v2" ;
  }
  private endpoint = `${this.apiUrl}/orders-details`; 
  // ✅ عدّل المسار لو مختلف في الكنترولر

  constructor(private http: HttpClient) {}

  getAllOrdersWithDetails(
    page: number,
    pageSize: number,
    orderId?: number | null,
    sortBy: SortBy = 'id',
    sortDir: SortDir = 'desc',
    search?: string | null
  ): Observable<PagedResult<CombinedOrderWithOrdersDto>> {

    let params = new HttpParams()
      .set('page', page)
      .set('pageSize', pageSize)
      .set('sortBy', sortBy)
      .set('sortDir', sortDir)
      .set('search', search);

    if (orderId != null) {
      params = params.set('orderId', orderId);
    }

    return this.http.get<PagedResult<CombinedOrderWithOrdersDto>>(
      this.endpoint,
      { params }
    );
  }
  UpdateOrdersStatus(updateOrdersStatus : UpdateOrdersStatus): Observable<any> {

    return this.http.post<any>(
      this.apiUrl+`/orders-status`,
       updateOrdersStatus 
    );
  }
  DeleteOrder(id : number): Observable<any> {

    return this.http.delete<any>(
      this.apiUrl+`/order/${id}` 
    );
  }
}
